function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import DesktopContentComponent from "./desktop-content/desktop-content-component";
import MobileContentComponent from "./mobile-content/mobile-content-component";
import YoutubeVideoModalComponent from "/components/core/youtube-video-modal/youtube-video-modal-component";
import { YOUTUBE_MODAL_OPEN, YOUTUBE_MODAL_CLOSE } from "/constants/bigbrain-event-types";
import { StyledOnePagerVideoContentComponent } from "./one-pager-with-video-content-component.scss";
class OnePagerVideoContentComponent extends PureComponent {
    onPlayButtonClicked() {
        const { popupVideo } = this.props;
        BigBrain("track", YOUTUBE_MODAL_OPEN, {
            kind: popupVideo.playButtonText
        });
        this.setState({
            openModal: true
        });
    }
    closeModal() {
        const { popupVideo } = this.props;
        BigBrain("track", YOUTUBE_MODAL_CLOSE, {
            kind: popupVideo.playButtonText
        });
        this.setState({
            openModal: false
        });
    }
    render() {
        const { openModal } = this.state;
        const { popupVideo, forceClosePopup } = this.props;
        return /*#__PURE__*/ _jsxs(StyledOnePagerVideoContentComponent, {
            className: "one-pager-with-video-content-component",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "desktop-content-wrapper",
                    children: /*#__PURE__*/ _jsx(DesktopContentComponent, _object_spread_props(_object_spread({}, this.props), {
                        onPlayButtonClicked: this.onPlayButtonClicked
                    }))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "mobile-content-wrapper",
                    children: /*#__PURE__*/ _jsx(MobileContentComponent, _object_spread({}, this.props))
                }),
                popupVideo.show && !forceClosePopup && /*#__PURE__*/ _jsx(YoutubeVideoModalComponent, _object_spread_props(_object_spread({}, popupVideo), {
                    minHeight: 546,
                    isOpen: openModal,
                    opts: {
                        width: 970,
                        height: 546,
                        playerVars: {
                            autoplay: 1,
                            rel: 0,
                            showinfo: 0
                        }
                    },
                    onCloseModal: this.closeModal
                }))
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            openModal: false
        };
        this.onPlayButtonClicked = this.onPlayButtonClicked.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }
}
export { OnePagerVideoContentComponent as default };
OnePagerVideoContentComponent.defaultProps = {
    textPart: {},
    imageWithBackgroundPart: {},
    collaborationWith: {},
    popupVideo: {}
};
